import mixitup from 'mixitup';

const filterContainerEls = [
    ...document.querySelectorAll('.floor-family-overview'),
    ...document.querySelectorAll('.decor-overview'),
];

filterContainerEls.forEach((filterContainerEl) => {
    const filterEl = filterContainerEl.querySelector('.filter');

    if (filterEl) {
        const filterSelector = filterContainerEl.dataset.filterSelector;

        const isFilterHidden = filterEl.classList.contains('filter--hidden');

        let mixer = undefined;

        if (filterSelector) {
            const activeFilters = processFilters(filterContainerEl.dataset.activeFilters, filterSelector);
            mixer = mixitup(filterContainerEl, mixitupConfig(filterSelector, isFilterHidden));

            if (activeFilters) {
                mixer.filter(activeFilters);
            }
        } else {
            console.warn('No filter selector found');
        }

        if (!isFilterHidden) {
            addFilterControlling(filterEl, mixer, filterSelector);
        }
    }
});

function addFilterControlling(filterEl, mixer, filterSelector) {
    const filterItemEls = filterEl.querySelectorAll('.filter__item');
    const mobileTriggerEl = filterEl.querySelector('.filter__mobile-trigger');
    const mobileCloseEl = filterEl.querySelector('.filter__mobile-close');
    const mobileResetEl = filterEl.querySelector('.filter__mobile-reset');
    const mobileSaveEl = filterEl.querySelector('.filter__mobile-save');

    const initialFilterString = window.location.search;

    let previousFilterString = initialFilterString;
    let filterParams = new URLSearchParams(initialFilterString);

    updateFilterOptions(filterParams);
    filterContent();

    filterItemEls.forEach((filterItemEl) => {
        const optionEls = filterItemEl.querySelectorAll('.filter__item-select-option input');

        optionEls.forEach((optionEl) => {
            optionEl.addEventListener('click', () => {
                changeFilterOption(filterItemEl, optionEl, optionEls);
            });

            optionEl.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    changeFilterOption(filterItemEl, optionEl, optionEls);
                }
            });
        });
    });

    if (mobileTriggerEl) {
        mobileTriggerEl.addEventListener('click', (event) => {
            filterEl.classList.toggle('filter--open');
            document.body.classList.toggle('-filter-open');
            previousFilterString = window.location.search;
        });
    }

    if (mobileCloseEl) {
        mobileCloseEl.addEventListener('click', (event) => {
            filterEl.classList.remove('filter--open');
            document.body.classList.remove('-filter-open');
            filterParams = new URLSearchParams(previousFilterString);
            updateFilterOptions(filterParams);
        });
    }

    if (mobileResetEl) {
        mobileResetEl.addEventListener('click', (event) => {
            filterParams = new URLSearchParams(previousFilterString);
            updateFilterOptions(filterParams);
        });
    }

    if (mobileSaveEl) {
        mobileSaveEl.addEventListener('click', (event) => {
            filterEl.classList.remove('filter--open');
            document.body.classList.remove('-filter-open');
            previousFilterString = filterParams.toString();
        });
    }

    // FUNCTIONS

    function changeFilterOption(filterItemEl, optionEl, optionEls) {
        const dropdownTriggerEl = filterItemEl.querySelector('.filter__item-select-trigger');
        const wasChecked = optionEl.dataset.wasChecked === 'true';

        optionEls.forEach((element) => {
            element.checked = false;
            element.dataset.wasChecked = false;
        });

        if (wasChecked) {
            optionEl.checked = false;
            optionEl.dataset.wasChecked = false;
        } else {
            optionEl.checked = true;
            optionEl.dataset.wasChecked = true;
        }

        if (dropdownTriggerEl) {
            const dropdownTriggerTextEl = dropdownTriggerEl.querySelector('span');
            if (optionEl.checked) {
                dropdownTriggerEl.classList.add('filter__item-select-trigger--active');
                dropdownTriggerTextEl.textContent = optionEl.dataset.label;
            } else {
                dropdownTriggerEl.classList.remove('filter__item-select-trigger--active');
                dropdownTriggerTextEl.textContent = dropdownTriggerTextEl.dataset.label;
            }
        }

        optionEl.focus();
        updateFilterItemParams(filterItemEl, optionEl);
        filterContent();
    }

    function filterContent() {
        if (!mixer || !filterSelector) {
            return;
        }

        const values = Array.from(filterParams.values());
        const filterString = values.length === 0 ? '' : `.${Array.from(filterParams.values()).join('.')}`;

        mixer.filter(processFilters(filterString, filterSelector));
    }

    function updateFilterOptions(selectedFilterParams) {
        [...filterItemEls].forEach((filterItemEl) => {
            const dropdownTriggerEl = filterItemEl.querySelector('.filter__item-select-trigger');
            const optionEls = filterItemEl.querySelectorAll('.filter__item-select-option input');

            if (dropdownTriggerEl) {
                const dropdownTriggerTextEl = dropdownTriggerEl.querySelector('span');
                dropdownTriggerEl.classList.remove('filter__item-select-trigger--active');
                dropdownTriggerTextEl.textContent = dropdownTriggerTextEl.dataset.label;
            }

            optionEls.forEach((optionEl) => {
                const selectedFilterParamsOption = selectedFilterParams.get(optionEl.name);
                if (selectedFilterParamsOption === optionEl.value) {
                    optionEl.checked = true;

                    if (dropdownTriggerEl) {
                        const dropdownTriggerTextEl = dropdownTriggerEl.querySelector('span');
                        dropdownTriggerEl.classList.add('filter__item-select-trigger--active');
                        dropdownTriggerTextEl.textContent = optionEl.dataset.label;
                    }
                } else {
                    optionEl.checked = false;
                }
                optionEl.dataset.wasChecked = optionEl.checked;
            });
        });

        const newUrl = new URL(window.location.href);
        newUrl.search = selectedFilterParams.toString();
        window.history.replaceState(window.history.state, '', newUrl);
    }

    function updateFilterItemParams(filterItemEl, targetOption) {
        const checkedOptionEl = filterItemEl.querySelector('.filter__item-select-option input:checked');

        if (checkedOptionEl) {
            filterParams.set(targetOption.name, checkedOptionEl.value);
        } else {
            filterParams.delete(targetOption.name);
        }

        const newUrl = new URL(window.location.href);
        newUrl.search = filterParams.toString();
        window.history.replaceState(window.history.state, '', newUrl);
    }
}

function mixitupConfig(filterSelector, isFilterHidden) {
    return {
        selectors: {
            target: filterSelector,
        },
        animation: {
            easing: 'ease-in-out',
            duration: isFilterHidden ? 0 : 600,
        },
    };
}

function processFilters(filters, filterSelector) {
    if (!filters || filters.length === 0) {
        return filterSelector ?? '';
    }

    return filters;
}
